module.exports = __webpack_public_path__ + "img/bx-time.df429b4f.svg";